import PlaceholderValue from '@/platform/common/components/PlaceholderValue/PlaceholderValue';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Link } from '@inertiajs/react';

const DocumentLink = ({ employee }) => {
    if (
        employee?.period?.reason_label !== 'AGH/SFB' ||
        (employee?.period?.reason_label === 'AGH/SFB' && !!employee.document_id)
    ) {
        return (
            <PlaceholderValue
                placeholder='n.v.t.'
                isPresent={!!employee.document_id}
            >
                <Link
                    href={`/documents/${employee.document_id}`}
                    target='_blank'
                >
                    <ArrowDownTrayIcon className='size-4' />
                </Link>
            </PlaceholderValue>
        );
    }

    return (
        <>
            <span className='text-gray-500'>n.v.t.</span>
            <Tooltip>
                <TooltipTrigger>
                    <InformationCircleIcon className='ml-2 size-4' />
                </TooltipTrigger>
                <TooltipContent>
                    Het is niet 100% zeker dat er voor de werknemer een
                    No-riskpolis geldt. De werknemer heeft in de vragenlijst
                    aangegeven een No-riskpolis te hebben, maar dit is niet
                    bevestigd door het UWV.
                </TooltipContent>
            </Tooltip>
        </>
    );
};

export default DocumentLink;
